import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  profileListById,
  profileSave,
} from '../../../shared/queries/AccessProfile';

import GraphQL from '../../../GraphQL';
import SmartCard from '../../../shared/components/SmartCard';
import AccessProfileForm from './Form';

const AccessProfileFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0, profileFeatures: [] });
  const [formOn, setFormOn] = useState(false);

  function backClickHandler() {
    history.push('/minime/acesso');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function findById(id) {
    const query = profileListById(id);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        if (res.profileList) {
          setDto({
            ...res.profileList[0],
            profileFeatures: [],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    const mutation = profileSave(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('mnt_access_profiles.title')}>
      {formOn ? (
        <AccessProfileForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          showLoading={showLoading}
          hideLoading={hideLoading}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

AccessProfileFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AccessProfileFormHandler)
);
